import {
  ConversationFilterNames,
  conversationFilterData,
} from "@redotech/effect-api-shared/schema/conversation-filters";
import TagIcon from "@redotech/redo-icons/tag-01.svg";
import type { EffectApiContext } from "@redotech/redo-merchant-app-common/effect-api-client-provider";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import type { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export function createCustomerTagsAdvancedFilter(
  effectApi?: EffectApiContext,
): ArrayStringTableFilter<string> {
  return {
    type: AdvancedFilterType.ARRAY_TO_STRING,
    Icon: TagIcon,
    operators: [
      ArrayStringFilterOperator.ANY_OF,
      ArrayStringFilterOperator.ALL_OF,
      ArrayStringFilterOperator.NONE_OF,
    ],
    data: conversationFilterData[ConversationFilterNames.CUSTOMER_TAGS],
    itemLabel: "tag",
    itemLabelPlural: "tags",
    displayName: "Customer tags",
    dbSearch: true,
    valueFetcher: effectApi
      ? async (_params, _signal) => {
          // TODO: Implement fetching customer tags from the API
          return [];
        }
      : undefined,
    display: (item: string) => item,
  };
}
